import { render, staticRenderFns } from "./PartCku.vue?vue&type=template&id=3c7662f2&"
import script from "./PartCku.vue?vue&type=script&lang=js&"
export * from "./PartCku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports